<template>
  <div :class="'eventItem --' + item.type" @click="getJustifyForm(item)">
    <div class="event__heading d-flex justify-content-between fst-italic">
      <span class="event__date">{{ $d(item.start_date) }}</span>
      <span class="event__date">{{ item.hours }}</span>
    </div>
    <h3 class="textStyle">
      {{ item.type === 3 ? $t("absence.absence") : item.title }}
    </h3>
    <div v-if="item.subject" class="event__subject">
      {{ item.subject }}
    </div>
    <div v-if="item.teacher" class="event__subject">
      {{ item.teacher }}
    </div>
    <div v-if="item.classRoom" class="event__subject">
      {{ item.classRoom }}
    </div>
    <button v-if="!item.justified && item.type === 3 && item.justifyStatus === 1" class="badge bg-danger">
      {{ $t("absence.not_justify") }}
    </button>
    <button v-if="item.type === 3 && item.justifyStatus === 2" class="badge bg-warning">
      {{ $t("absence.in_progress") }}
    </button>
  </div>
</template>

<script>
export default {
  name: "AbsenceAction",
  props: {
    item: {
      type: Object,
      required: true,
    },
    isStudeaManager: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["getJustifyForm"],
  methods: {
    getJustifyForm(item) {
      this.$emit("getJustifyForm", item);
    },
  },
};
</script>

<style lang="scss" scoped>
.eventItem {
  border-left: 5px solid $light-grey;
  padding: 3px 3px 3px 10px;
  cursor: pointer;

  &.--0 {
    border-color: $success;
  }

  &.--1 {
    border-color: $primary;
  }

  &.--3 {
    border-color: $warning;
  }

  &:hover,
  &:focus {
    background: $m-color_2;
    @include dark-theme {
      background-color: $dark-grey;
    }
  }
}
</style>
